import { render } from "./LakeviewParameters.vue?vue&type=template&id=95708d62"
import script from "./LakeviewParameters.vue?vue&type=script&lang=js"
export * from "./LakeviewParameters.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__